export default __webpack_public_path__ + "static/media/cares.51eca50c.png";